import { TextField } from "@mui/material";
import React from "react";
import CalendarDateInput from "../../../common/dashboard/CalendarDateInput";
import { invoiceFieldSx } from "../../Invoicing/InvoiceDesignSystem";
import { eventInvoiceReferenceMaxLength } from "./eventInvoiceCreateState";

type EventInvoiceCreateFieldsProps = Readonly<{
  dueDate: string;
  dueDateError?: string;
  invoiceDate: string;
  invoiceDateError?: string;
  headingClassName?: string;
  onDueDateChange: (value: string) => void;
  onInvoiceDateChange: (value: string) => void;
  onReferenceChange: (value: string) => void;
  reference: string;
}>;

const EventInvoiceCreateFields = ({
  dueDate,
  dueDateError,
  invoiceDate,
  invoiceDateError,
  headingClassName = "text-xl font-bold text-gray-950",
  onDueDateChange,
  onInvoiceDateChange,
  onReferenceChange,
  reference,
}: EventInvoiceCreateFieldsProps): React.ReactElement => (
  <div className="space-y-[26px]">
    <h3 className={headingClassName}>Invoice Details</h3>
    <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
      <div className="space-y-1.5">
        <label className="block text-[14px] font-bold leading-[18px] text-[#0A0A0A]">
          Invoice Date <span className="text-red-500">*</span>
        </label>
        <CalendarDateInput mode="fullDate" ariaLabel="Invoice Date" appearance="claude"
          iconPosition="left" placeholder="Select date" value={invoiceDate}
          onChange={onInvoiceDateChange} ariaInvalid={Boolean(invoiceDateError)}
          inputClassName="h-[42px] w-full rounded-lg border border-[#e5e5e5] bg-white px-3 text-sm" />
        {invoiceDateError ? <p className="text-xs text-red-600">{invoiceDateError}</p> : null}
      </div>
      <div className="space-y-1.5">
        <label className="block text-[14px] font-bold leading-[18px] text-[#0A0A0A]">
          Due Date <span className="text-red-500">*</span>
        </label>
        <CalendarDateInput mode="fullDate" ariaLabel="Due Date" appearance="claude"
          iconPosition="left" placeholder="Select date" value={dueDate}
          onChange={onDueDateChange} ariaInvalid={Boolean(dueDateError)}
          inputClassName="h-[42px] w-full rounded-lg border border-[#e5e5e5] bg-white px-3 text-sm" />
        {dueDateError ? <p className="text-xs text-red-600">{dueDateError}</p> : null}
      </div>
      <div className="space-y-1.5">
        <label className="block text-[14px] font-bold leading-[18px] text-[#0A0A0A]">
          Reference / PO Number (Optional)
        </label>
        <TextField
          fullWidth
          inputProps={{
            "aria-label": "Reference / PO Number (Optional)",
            maxLength: eventInvoiceReferenceMaxLength,
          }}
          onChange={({ target }) => onReferenceChange(target.value)}
          placeholder="Enter Reference / PO Number"
          sx={[invoiceFieldSx, { "& .MuiOutlinedInput-notchedOutline": { borderColor: "#e5e5e5 !important" } }]}
          value={reference}
        />
      </div>
    </div>
  </div>
);

export default EventInvoiceCreateFields;
